import {layoutMarkup} from "../layout/layoutMarkup.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import EditorHelpers from "../../common/EditorHelpers";
import {paragraphDefaultContent} from './paragraphSectionDefaultContent';
import {componentsHelper} from "../../helpers/componentsHelper";
import l10n from "../../../lang/locallang";
const paragraphSection = async (param, is_public = false) => {
    componentsHelper.updateLocalization(paragraphDefaultContent);
    const { paragraphText } = l10n;
    param.class = param.class ? param.class : 'editor-section';
    let content = param.content && param.content.text ? param.content.text : `<p>${paragraphText.content}</p>`;
    // Check if content is provided, otherwise fetch AI placeholder
    //let content = '';
    if (param.content && param.content.text) {
        content = param.content.text;
    } else {
        //content = await aiContent.requestForAIPlaceholder('paragraphSection', param.topic, param.lesson_name);
    }
    param.style = param.style ? param.style : '';
    param.section = 'paragraphSection';
    param.component = `<div class="editor-section_container fr-editor-container">

         <div class="fr-editor-paragraph" id="input_text_section_${param.id}">

            ${EditorHelpers.fixEncoding(content)}
        </div>`;
    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

export {paragraphSection};
/*<div class="ai-paragraph">
                <span>AI Suggestions</span>
                 <div class="ai-paragraph-tips">
                    <div class="ai-paragraph-tip"><span>Intro for lesson: What is HTML?</span></div>
                    <div class="ai-paragraph-tip"><span>Definition of HTML</span></div>
                    <div class="ai-paragraph-tip"><span>What is HTML?</span></div>
                </div>
            </div>*/
